module.exports = __webpack_public_path__ + "aa8fdddd047809c14a32f517b60e6c21.svg";